import { render } from "./ViewsErrors404.vue?vue&type=template&id=724f3a2a"
import script from "./ViewsErrors404.vue?vue&type=script&lang=js"
export * from "./ViewsErrors404.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__